import React from "react"
import "./landing.scss"
import { Ruta } from "../../../Ruta"

export const HeaderSection = ({rutaTitle, title, classTitle }) => {
  return (
    <>
      <div className={`${classTitle}-portada-container`}>
        <img
          src={`../../soluciones/${classTitle}/header-${classTitle}.jpg`}
          alt={`portada ${classTitle}`}
        />
      </div>
      <div className={`ruta-${classTitle}-container`}>
        <Ruta rutaTitle={rutaTitle} title={title} classTitle={classTitle} />
      </div>
    </>
  )
}
